import React from 'react';
import {
  Container,
  IconContainer,
  ProgressBar,
  StepItem,
  StepItemContent,
  SteppperBox
} from './MultiStep.elements';
import { useTranslation } from 'react-i18next';
import { TooltipWrapper, Typography } from 'components';
import theme from 'themes';
import Check from 'icons/indexed-icons/Check';
import styledTheme from 'common/theme';

interface StepType {
  name?: string;
  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
  icon?: any;
  stepIndex?: number;
}
interface MultiStepProps {
  steps?: StepType[];
  currentStep?: number;
  handlePress?: (index: number) => void;
  isEmpty?: boolean;
  isTwowaySync?: boolean;
  cartPriceType?: string;
  cartItemsType?: string;
}
const MultiStepIndicator = ({
  steps,
  currentStep = 0,
  handlePress,
  isEmpty,
  isTwowaySync,
  cartPriceType,
  cartItemsType
}: MultiStepProps): JSX.Element => {
  const { t } = useTranslation(['fpns']);
  const isDisabledStep = currentStep === 2 && isTwowaySync && cartPriceType !== 'mix';

  // if (currentStep === 2 && isTwowaySync && cartPriceType !== 'mix') {
  //   currentStep = 3;
  // }

  if (currentStep === 2 && (cartPriceType !== 'mix' || !isTwowaySync)) {
    currentStep = 3;
  }

  return (
    <SteppperBox>
      <Container margin={'0 2.375rem'}>
        {steps?.map((step, i) => {
          const { name = '', icon: Icon, stepIndex } = step;
          const isPrev = i < currentStep;
          const active = isEmpty ? false : i === currentStep;

          return (
            <>
              {stepIndex !== undefined && stepIndex !== 2 && (
                <>
                  <StepItem
                    onClick={() => handlePress && handlePress(i)}
                    color={
                      active || isPrev || currentStep === 3
                        ? theme.colors.primaryBlue5
                        : theme.colors.mediumGrey4
                    }
                    key={name}
                  >
                    <StepItemContent>
                      {Icon && (
                        <IconContainer isActive={active || currentStep === 3} isPrevious={isPrev}>
                          {isPrev ? (
                            <Check />
                          ) : (
                            <Icon
                              width={24}
                              color={
                                active || currentStep === 3 || isPrev
                                  ? styledTheme.colors.white
                                  : styledTheme.colors.gray600
                              }
                            />
                          )}
                        </IconContainer>
                      )}
                      <Typography
                        color={
                          isPrev || active ? styledTheme.colors.gray800 : styledTheme.colors.gray600
                        }
                        size={'1rem'}
                        weight="medium"
                        mb={0}
                      >
                        {t(name)}
                      </Typography>
                    </StepItemContent>
                  </StepItem>
                  {i !== steps.length - 1 && (
                    <ProgressBar className="animate" isPrev={isPrev} active={active}></ProgressBar>
                  )}
                </>
              )}

              {isTwowaySync &&
                stepIndex !== undefined &&
                stepIndex === 2 &&
                cartItemsType === 'mix' && (
                  <>
                    <>
                      <StepItem
                        onClick={() => handlePress && handlePress(i)}
                        color={
                          active || isPrev ? theme.colors.primaryBlue5 : theme.colors.mediumGrey4
                        }
                        key={name}
                      >
                        <StepItemContent>
                          {Icon && (
                            <IconContainer isActive={active} isPrevious={isPrev}>
                              {isPrev && !isDisabledStep ? (
                                <Check />
                              ) : (
                                <Icon
                                  width={24}
                                  color={
                                    active || isPrev
                                      ? styledTheme.colors.white
                                      : cartPriceType === 'mix'
                                      ? styledTheme.colors.gray600
                                      : styledTheme.colors.gray300
                                  }
                                />
                              )}
                            </IconContainer>
                          )}
                          <Typography
                            color={
                              (isPrev || active) && !isDisabledStep
                                ? styledTheme.colors.gray800
                                : cartPriceType === 'mix'
                                ? styledTheme.colors.gray600
                                : styledTheme.colors.gray300
                            }
                            size={'1rem'}
                            weight="medium"
                            mb={0}
                          >
                            {t(name)}
                          </Typography>
                        </StepItemContent>
                      </StepItem>
                    </>

                    {i !== steps.length - 1 && (
                      <ProgressBar
                        className="animate"
                        isPrev={isPrev}
                        active={active}
                      ></ProgressBar>
                    )}
                  </>
                )}
            </>
          );
        })}
      </Container>
    </SteppperBox>
  );
};

export default MultiStepIndicator;
